// ドメインごとの色（bg / text / border）
const DOMAIN_COLORS = new Map<string, string>([
  ['monsnode', 'bg-violet-500/15 text-violet-400 border-violet-500/30'],
  ['nh', 'bg-pink-500/15 text-pink-400 border-pink-500/30'],
  ['line', 'bg-green-500/15 text-green-400 border-green-500/30'],
  ['fod', 'bg-orange-500/15 text-orange-400 border-orange-500/30'],
  ['abema', 'bg-emerald-500/15 text-emerald-400 border-emerald-500/30'],
  ['tver', 'bg-sky-500/15 text-sky-400 border-sky-500/30'],
  ['jcom', 'bg-red-500/15 text-red-400 border-red-500/30'],
  ['jump', 'bg-yellow-500/15 text-yellow-400 border-yellow-500/30'],
  ['piccoma', 'bg-amber-500/15 text-amber-400 border-amber-500/30'],
  ['kadokomi', 'bg-lime-500/15 text-lime-400 border-lime-500/30'],
  ['zozo', 'bg-cyan-500/15 text-cyan-400 border-cyan-500/30'],
  ['x', 'bg-zinc-500/15 text-zinc-400 border-zinc-500/30'],
  ['eufy', 'bg-teal-500/15 text-teal-400 border-teal-500/30'],
  ['garmin', 'bg-blue-500/15 text-blue-400 border-blue-500/30'],
  ['apple_music', 'bg-rose-500/15 text-rose-400 border-rose-500/30'],
  ['miss', 'bg-fuchsia-500/15 text-fuchsia-400 border-fuchsia-500/30'],
  ['audiobook', 'bg-indigo-500/15 text-indigo-400 border-indigo-500/30'],
  ['english', 'bg-emerald-500/15 text-emerald-400 border-emerald-500/30'],
  ['netflix', 'bg-red-600/15 text-red-500 border-red-600/30'],
  ['unext', 'bg-purple-500/15 text-purple-400 border-purple-500/30'],
])

export const getDomainColor = (domain: string) =>
  DOMAIN_COLORS.get(domain) ?? 'bg-muted text-muted-foreground border-border'
